import React from 'react'

function Gantt() {
  return (
    <div className="container-fluid p-3" style={{backgroundColor:'#F9FAFB',borderRadius:10,color:'#000',overflowY:'auto',height:'68vh'}}>
    <h3>Summary</h3>
    <p>Client Name: Demo Title</p>
    <p>Client Email: demo@gmail.com</p>
    <p>Location: Bangalore</p>
    <p>Project Name: Demo Project</p>
    <p>Project Description: Demo Project Description</p>
    <p>Project Budget: 10000</p>
    <p>Project Status: In Progress</p>
    <p>Project Start Date: 01/01/2020</p>
    <p>Project End Date: 01/01/2020</p>
    <p>Project Duration: 1 Month</p>

    <h3>History</h3>
    <p>Client Name: Demo Title</p>
   </div>
  )
}

export default Gantt